import React from "react";
import { Link } from "gatsby";
import '../home.css'
const TabCard = ({ data, gr_color }) => {
  const { heading, heading_color, card_image, buttons } = data;

  return (
    <div className="bg-transparent rounded-[4vw] xl:rounded-[7vh] overflow-hidden w-[100%] xl:w-[100%] mx-auto">
      {/* Background image with gradient overlay */}
      <div
        className="relative min-h-[43vh] md:min-h-[42vh] xl:min-h-[42vh] w-full bg-cover bg-center tab-card-item"
        style={{ backgroundImage: `url(${card_image.url})` }}
      >
        {/* Gradient overlay */}

        <div
          className="absolute inset-0 opacity-90"
          style={{
            backgroundImage: `linear-gradient(to bottom, ${gr_color}, transparent)`,
          }}
        />
        {/* Heading */}
        <div
          className="absolute top-[4vh] w-full text-center lg:text-[4vh] md:text-[3.5vh] text-[3.5vh]  font-bold px-[2vh] tab-card-heading"
          style={{ 
            color: heading_color,
            textShadow: "0 0 6px rgba(0,0,0,0.8)"
          }}
        >
          {heading}
        </div>

        {/* All 3 buttons stacked inside */}
        <div className="absolute lg:bottom-[6vh] md:bottom-[3vh] bottom-[4vh] w-full px-[3vh] flex flex-col gap-[2vw] md:gap-[1.5vw] lg:gap-[1vw]">
          {/* Top 2 buttons side-by-side */}
          <div className="flex flex-col xl:flex-row justify-between mt-[5vw] xl:mt-0 gap-[2vw] md:gap-[1.5vw] lg:gap-[1vw]">
            <Link
              aria-label={`Go to ${buttons[0].label}`}
              to={buttons[0].href}
              className="flex flex-row items-center justify-center w-full xl:w-[48%] gap-[2vw] md:gap-[1.5vw] lg:gap-[1vw] rounded-[1vh] px-[2vh] py-[1.2vh]"
              style={{ backgroundColor: buttons[0].bg_color }}
            >
              <img
                src={buttons[0].icon.url}
                alt={buttons[0].icon.alternativeText || `${buttons[0].label} icon` }
                className="w-[3.5vh] h-[3.5vh]"
              />
              <span
                className="text-[2vh] xl:text-[2.2vh] text-center font-normal leading-none home-link-text"
                style={{ color: buttons[0].label_color }}
              >
                {buttons[0].label}
              </span>
            </Link>

            <Link
              aria-label={`Go to ${buttons[1].label}`}
              to={buttons[1].href}
              className="flex flex-row items-center justify-center w-full xl:w-[48%] gap-[3vw] xl:gap-[1.5vh] rounded-[1vh] px-[2vh] py-[1.2vh]"
              style={{ backgroundColor: buttons[1].bg_color }}
            >
              <img
                src={buttons[1].icon.url}
                alt={buttons[1].icon.alternativeText || `${buttons[1].label} icon`}
                className="w-[3.5vh] h-[3.5vh]"
              />
              <span
                className="text-[2vh] xl:text-[2.2vh] text-center font-normal leading-none home-link-text"
                style={{ color: buttons[1].label_color }}
              >
                {buttons[1].label}
              </span>
            </Link>
          </div>

          {/* Third button full width */}
          <Link
            aria-label={`Go to ${buttons[2].label}`}
            to={buttons[2].href}
            className="flex flex-row items-center justify-center w-full gap-[3vw] xl:gap-[1.5vh] rounded-[1vh] px-[2vh] py-[1.2vh]"
            style={{ backgroundColor: buttons[2].bg_color }}
          >
            <img
              src={buttons[2].icon.url}
              alt={buttons[2].icon.alternativeText || `${buttons[2].label} icon`}
              className="w-[3.5vh] h-[3.5vh]"
            />
            <span
              className="text-[2vh] xl:text-[2.2vh] text-center font-normal leading-none home-link-text"
              style={{ color: buttons[2].label_color }}
            >
              {buttons[2].label}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TabCard;
